import { Action } from 'redux';

import { SpaceType } from '~src/app/state/SpaceInfo';

import { PublishedConnectionCountsRequest } from '../../app/actions/AppActionTypes';

export interface PublishedConnectionCountsRequestAction extends Action {
  spaceType: SpaceType;
}

export function publishedConnectionCountsRequest(
  spaceType: SpaceType
): PublishedConnectionCountsRequestAction {
  return {
    type: PublishedConnectionCountsRequest,
    spaceType
  };
}
